module.exports = __webpack_public_path__ + "img/23.071999b8.gif";